import React from 'react';
import { Box, Grid, Typography, Paper, Stack } from '@mui/material';
import icon1 from './img/icon1.svg';
import icon2 from './img/icon2.svg';
import icon3 from './img/icon3.svg';
import icon4 from './img/icon4.svg';

const cards = [
    {
        icon: icon1,
        title: 'Simple platform, substantial impact',
        description:
            'Drive maximum impact by using WhatsApp for not just promotional activities, but also customer support, order tracking, appointment schedulingand more.',
    },
    {
        icon: icon2,
        title: 'Personalized conversations',
        description:
            'Catch your prospects and customers on a platform where they are highly active. Even when you are away, set up chatbots that can provide human-like assistance.',
    },
    {
        icon: icon3,
        title: 'Connect & convert leads instantly',
        description:
            'Leverage the power of the omnipotent channel, WhatsApp. Right from lead capturing to closing deals, do everything on WhatsApp with Gallabox’s marketing automations.',
    },
    {
        icon: icon4,
        title: 'Cost-effective medium',
        description:
            'Unlike traditional platforms, WhatsApp is a low-cost marketing channel. This affordability makes it perfect for businesses of all shapes and sizes across industries.',
    },
];

const UseWhatsAppMarketing = () => {
    return (
        <Box
            sx={{
                background: 'linear-gradient(135deg, #0f172a, #1e3a8a)',
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            <Box
                sx={{
                    // px: 4,
                    py: 8,
                    color: 'white',
                    width: { xl: "74%", lg: "90%", md: "90%", sm: "90%" },
                    px: { xs: 4, lg: 0 },
                }}
            >
                <Typography
                    variant="h3"
                    sx={{
                        fontSize: { xs: '2.2rem', md: '3.5rem' },
                        fontWeight: 600,
                        mb: 6,
                        textAlign: 'center'
                    }}
                >
                    Why use <span style={{ color: 'rgb(80, 188, 119)' }}>WhatsApp</span> for marketing?
                </Typography>

                <Grid
                    container spacing={3}
                    justifyContent="center"
                >
                    {cards.map((card, index) => (
                        <Grid
                            item
                            key={index}
                            xs={12}
                            sm={6}
                            lg={3}
                            xl={3}
                        >
                            <Paper
                                elevation={4}
                                sx={{
                                    height: { xs: 300, md: 350 },
                                    p: 3,
                                    borderRadius: 2,
                                    backgroundColor: 'white',
                                    color: '#0f172a',
                                    textAlign: 'left',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    '&:hover': {
                                        transform: 'scale(1.05)',
                                        boxShadow: 6,
                                        cursor: 'pointer',
                                    },
                                }}
                            >
                                <Stack>
                                    <Box mb={2}>
                                        <img
                                            src={card.icon}
                                            alt={card.title}
                                            style={{
                                                width: 48,
                                                height: 48
                                            }}
                                        />
                                    </Box>

                                    <Typography
                                        fontSize={{ xs: '1.3rem', md: '1.5rem', lg: '1.3rem', xl: '1.5rem' }}
                                        fontWeight="bold"
                                        gutterBottom
                                    >
                                        {card.title}
                                    </Typography>

                                    <Typography
                                        variant="body2"
                                        sx={{ fontSize: '1rem' }}
                                    >
                                        {card.description}
                                    </Typography>

                                </Stack>

                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>

    );
};

export default UseWhatsAppMarketing;
